export default "/static/webpack/media/next.3f051b30.svg";